<template>
  <router-view :key="$route.path"></router-view>

  <!-- <p v-if="userLat && userLng">
      Your location: {{ userLat }}, {{ userLng }}
    </p>
    <p v-else>
      Getting your location...
    </p> -->

  <div class="whatsapp-float">
      <div class="support-text hide-mobile" v-if="isHovered">
        {{$t('chat_with_support')}}
      </div>
      <a href="https://wa.me/97433239950" target="_blank" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
        <img src="../src/assets/images/WhatsApp.svg" alt="WhatsApp">
      </a>
  </div>

  <ChatBot />
</template>

<script>
import $ from 'jquery'
import ChatBot from './components/chatbot/ChatBot.vue'
export default {
  components: {
    ChatBot,
  },
  data() {
    return {
      isHovered: false,
       userLat: null,
      userLng: null,
    }
  },
  methods: {
    
      handleMouseOver() {
          this.isHovered = true;
      },
      handleMouseLeave() {
          this.isHovered = false;
      },
      getUserLocation() {
        // Check if browser supports geolocation
        if (!navigator.geolocation) {
          alert("Geolocation is not supported by your browser");
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const currentLat = position.coords.latitude;
            const currentLng = position.coords.longitude;

            const storedLat = parseFloat(localStorage.getItem("userLat"));
            const storedLng = parseFloat(localStorage.getItem("userLng"));

            // If stored coordinates exist AND are the same, do nothing
            if (storedLat && storedLng) {
              const latChanged = Math.abs(storedLat - currentLat) > 0.0001;
              const lngChanged = Math.abs(storedLng - currentLng) > 0.0001;

              if (!latChanged && !lngChanged) {
                this.userLat = storedLat;
                this.userLng = storedLng;
                console.log("User location unchanged, using stored coordinates.");
                return;
              }
            }

            // Either no stored coords OR location changed → update
            this.userLat = currentLat;
            this.userLng = currentLng;

            localStorage.setItem("userLat", currentLat);
            localStorage.setItem("userLng", currentLng);

            console.log("Updated user location:");
            console.log("Lat:", currentLat, "Lng:", currentLng);

          
          },
          (error) => {
            console.error("Error getting location:", error);
          },
          { enableHighAccuracy: true }
        );
      },

  },
  watch: {
    '$route'(to) {
      // Update language and direction on route change (including browser navigation)
      const lang = to.params.lang;
      if (lang) {
        const langUpper = lang.toUpperCase();
        localStorage.setItem('amaken_language', langUpper);
        
        // Update body direction class
        if (lang === 'ar') {
          $('body').addClass('direction-rtl');
        } else {
          $('body').removeClass('direction-rtl');
        }
      }
    }
  },
  created() {
    // Get language from URL or localStorage
    const currentPath = window.location.pathname;
    let lang = 'EN';
    
    if (currentPath.startsWith('/en')) {
      lang = 'EN';
      localStorage.setItem('amaken_language', 'EN');
    } else if (currentPath.startsWith('/ar')) {
      lang = 'AR';
      localStorage.setItem('amaken_language', 'AR');
    } else {
      lang = localStorage.getItem('amaken_language') || 'EN';
    }

    if (lang == 'EN') {
      $('body').removeClass('direction-rtl');
    } else if (lang == 'AR') {
      $('body').addClass('direction-rtl');
    }

    this.getUserLocation();
  } 
  
}
</script>